<script lang="ts">
	import { NewsletterDialog } from '#lib/features/newsletter/components/NewsletterDialog/index.js';
	import {
		NewsletterMixpanelEvents,
		NewsletterProvenance,
	} from '#lib/features/newsletter/constants/mixpanel-events.js';
	import { isOnProductionOnly } from '#lib/utils/env/isOnProductionOnly/isOnProductionOnly.js';
	import { Button } from '$global/components/Button';
	import { createDialogStores } from '$global/components/Dialog';
	import { Txt } from '$global/components/Txt';
	import { getImageUrl } from '$global/utils/getImageUrl';
	import { track } from '$global/utils/track';

	interface Props {
		dataCy: string;
		src?: string | null | undefined;
		artistName: string;
		listId: number;
		testListId: number;
	}

	let {
		dataCy,
		src = undefined,
		artistName,
		listId,
		testListId,
	}: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-updates-card`);

	const newsletterDialogStores = createDialogStores();

	let newsletterListId = $derived(isOnProductionOnly() ? listId : testListId);

	const handleClick = () => {
		track(NewsletterMixpanelEvents.OpenNewsletterDialog, {
			provenance: NewsletterProvenance.Artist,
			listId,
		});

		newsletterDialogStores.states.open.set(true);
	};
</script>

<div class="flex flex-col rounded border">
	{#if src}
		<div class="bg-gray-200">
			<img
				src={getImageUrl(src)}
				data-cy={`${dataCyPrefix}-image`}
				alt={artistName}
				class="aspect-square w-full max-w-full rounded-t object-cover"
			/>
		</div>
	{/if}
	<div class="flex flex-col justify-end bg-gray-100 px-8 pt-3 pb-5">
		<div class="self-center">
			<Txt variant="h6" class="mb-1.5 text-center"
				>{`Interested in ${artistName}?`}</Txt
			>
		</div>
		<Button
			{dataCy}
			variant="primary"
			size="sm"
			fullWidth
			onclick={handleClick}
		>
			GET UPDATES
		</Button>
	</div>
</div>

<NewsletterDialog
	dataCy={dataCyPrefix}
	listId={newsletterListId}
	provenance={NewsletterProvenance.Artist}
	title="Get the latest updates"
	description={`Sign up for the HENI Newsletter to receive updates on future releases,
		collaborations and events with ${artistName} and other artists.`}
	dialogStores={newsletterDialogStores}
/>
